// extracted by mini-css-extract-plugin
export default {"text":"PeriodNotice_text__8AHvK","text_red":"PeriodNotice_text_red__3eXIM"};